export default __webpack_public_path__ + "static/media/lc.57a1f414.svg";